import { Fetcher } from "./index";

export function requestTour(id: string) {
  return async (fetcher: Fetcher) => {
    await fetcher(`salons/${id}/request_tour`, {
      method: "GET",
    });
  };
}
